import { createSummaryCardsConfig } from '../email-pulse-config-defaults';

/**
 * Configuration for Overview tab summary cards
 */
export const overviewSummaryCardsConfig = createSummaryCardsConfig(
  'overviewSummary',
  'OverviewSummaryCards',
);
